import { parseSearchResults, SearchResultsResponse } from 'components/discovery/shared/search/typing/search-results.js'

export class SearchProductsParser {
  parseSearchResultsResponse = (response: unknown): SearchResultsResponse => {
    return parseSearchResults(response)
  }
}
